import React from "react";
import { Mic, Brain } from "lucide-react";
import { WAVEFORM_BAR_COUNT, WAVEFORM_ANIMATION_DOTS } from "../constants";
import { useSelector } from "react-redux";

const AudioWaveform = ({ isPlaying, isRecording, isNextQuestionLoading, isWaitingForTechnicalAcknowledge, hideSpeakingBars = false }) => {
  const {whitelabelEnabled:isWhiteLabelingEnable} = useSelector((state)=>state.miscSlice)

  return (
    <div className="flex items-center justify-center gap-8 mt-4">
      {!hideSpeakingBars && isPlaying && !isRecording && !isNextQuestionLoading && (
        <div className="audio-waveform">
          {[...Array(WAVEFORM_BAR_COUNT)].map((_, i) => (
            <div key={i} className="waveform-bar" />
          ))}
        </div>
      )}

      {isRecording && !isPlaying && !isNextQuestionLoading && !isWaitingForTechnicalAcknowledge && (
        <div className="audio-waveform">
          <Mic className="w-5 h-5 text-red-500 animate-pulse" />
          <p className={`text-xl font-light ml-4 ${isWhiteLabelingEnable ? 'text-gray-700' :'text-[#D9D9D9] '}`}>
            Listening
          </p>
          <div className="flex gap-1 ml-2">
            {[...Array(WAVEFORM_ANIMATION_DOTS)].map((_, i) => (
              <div
                key={i}
                className="w-1.5 h-1.5 bg-red-500 rounded-full animate-bounce"
                style={{ animationDelay: `${i * 0.15}s` }}
              />
            ))}
          </div>
        </div>
      )}

      {isNextQuestionLoading && !isPlaying && !isRecording && (
        <div className="audio-waveform">
          <Brain className="w-5 h-5 text-red-500 animate-pulse" />
          <p className={`text-xl font-light ml-4 ${isWhiteLabelingEnable ? 'text-gray-700' :'text-[#D9D9D9] '}`}>
            Analyzing response
          </p>
          <div className="flex gap-1 ml-2">
            {[...Array(WAVEFORM_ANIMATION_DOTS)].map((_, i) => (
              <div
                key={i}
                className="w-1.5 h-1.5 bg-red-500 rounded-full animate-bounce"
                style={{ animationDelay: `${i * 0.15}s` }}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default AudioWaveform;
